import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "section-header" }
const _hoisted_2 = { class: "section-title" }
const _hoisted_3 = {
  key: 1,
  class: "section-meta"
}
const _hoisted_4 = {
  key: 0,
  class: "section-actions"
}


export default {
  __name: 'SectionHeader',
  props: {
  title: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
    default: '',
  },
  iconColorClass: {
    type: String,
    default: 'text-muted',
  },
  meta: {
    type: String,
    default: '',
  },
},
  setup(__props) {



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.icon)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: _normalizeClass([__props.icon, __props.iconColorClass])
          }, null, 2 /* CLASS */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("span", null, _toDisplayString(__props.title), 1 /* TEXT */),
      (__props.meta)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.meta), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ]),
    (_ctx.$slots.actions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "actions")
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

}